// Module
var code = `<template> <div class="partial-require-inspection column"> <div class="row"> <check-box class="col-gutter align-self-center" checked.two-way="meta.hiddenFromBanner" value="Hide from banner"></check-box> </div> </div> </template>`;
// Exports
module.exports = code;